import React from "react";

const suggestions = [
  {
    id: "approve-all",
    icon: "/Images/check.svg",
    tone: "success",
    label: "Approve all pending items",
  },
  {
    id: "payroll-details",
    icon: "/Images/action.svg",
    tone: "payroll",
    label: "Show payroll details",
  },
  {
    id: "transactions",
    icon: "/Images/track-transaction.svg",
    tone: "transactions",
    label: "Track today's transactions",
  },
  {
    id: "pending",
    icon: "/Images/question.svg",
    tone: "question",
    label: "What's pending for approval?",
  },
];

export default function AiSuggestedActions({ onSelect }) {
  return (
    <div className="ai-suggested-actions">
      <p>Would you like me to help with any of these?</p>
      <div className="ai-suggested-actions__chips">
        {suggestions.map((suggestion) => (
          <button
            key={suggestion.id}
            type="button"
            onClick={() => onSelect?.(suggestion.label)}
          >
            <span
              className={`ai-suggested-actions__icon is-${suggestion.tone}`}
              aria-hidden="true"
            >
              <img src={suggestion.icon} alt="" />
            </span>
            <span>{suggestion.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
